/**
 * Data & Analytics Discovery — the second Extern Labs vertical.
 *
 * Deliberately a SIBLING of `finance-discovery-events.ts` rather than a shared factory that builds
 * names from a prefix: the event names must stay LITERAL so they are greppable, land in Mixpanel's
 * Lexicon, and survive the tracking-guard's `track(EVENTS.NAME)` detection. Same event vocabulary as
 * finance (the engine emits the same milestones for every vertical) — only the prefix differs, so
 * the two verticals can be read side by side on one board.
 */
export const DATA_DISCOVERY_EVENTS = {
  ELIGIBILITY_RESOLVED: 'data_discovery_eligibility_resolved',
  // Fired on /payment for BOTH arms, BEFORE the paywall. The ITT denominator for the pre-paywall
  // conversion read — ELIGIBILITY_RESOLVED fires at checkout success, which is after this moment.
  PREPAYWALL_ELIGIBILITY_RESOLVED: 'data_discovery_prepaywall_eligibility_resolved',
  ENTERED: 'data_discovery_entered',
  // THE PRE-PAYWALL HAND-OFF, the conversion mechanic. An unpaid learner who finishes the sprint meets
  // a modal that names the artifact they just made and asks for the trial. HANDOFF_SHOWN is the
  // denominator for that ask; TRIAL_CLICKED over SHOWN is the conversion rate this experiment exists to
  // move. A subscribed learner never fires any of the three.
  HANDOFF_SHOWN: 'data_discovery_handoff_shown',
  HANDOFF_TRIAL_CLICKED: 'data_discovery_handoff_trial_clicked',
  HANDOFF_DISMISSED: 'data_discovery_handoff_dismissed',
  // Per-step progress — emitted the FIRST time each of the 18 steps is reached. Powers the
  // abandon-point funnel (the furthest stepIndex a user reaches = their completion %).
  STEP_VIEWED: 'data_discovery_step_viewed',
  MODULE_COMPLETED: 'data_discovery_module_completed',
  ARCHETYPE_REVEALED: 'data_discovery_archetype_revealed',
  FLOW_COMPLETED: 'data_discovery_flow_completed',
  RECOMMENDATION_CLICKED: 'data_discovery_recommendation_clicked',
  OFFER_SHOWN: 'data_discovery_offer_shown',
  OFFER_STARTED: 'data_discovery_offer_started',
  OFFER_DISMISSED: 'data_discovery_offer_dismissed',
  // THE IN-SPRINT TRIAL BAR — pinned to the bottom of every sprint screen for unpaid learners.
  // Asks for the trial DURING the work, where HANDOFF_* asks after it. Kept as its own pair so
  // the two moments can be compared instead of blended.
  TRIAL_BAR_SHOWN: 'data_discovery_trial_bar_shown',
  TRIAL_BAR_CLICKED: 'data_discovery_trial_bar_clicked',
} as const;

export type DataDiscoveryEventName = (typeof DATA_DISCOVERY_EVENTS)[keyof typeof DATA_DISCOVERY_EVENTS];
